import styled from "styled-components";

export const LoadingWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-content: center;
    background-color: white;
`;

export const ResponsiveButtonWrapper = styled.div`
    width: ${({ $isSmallScreen }) => ($isSmallScreen ? "100%" : "auto")};
`;
